export const ADD_HIGH_SCHOOL = 'ADD_HIGH_SCHOOL';
export const DELETE_HIGH_SCHOOL = 'DELETE_HIGH_SCHOOL';
export const ADD_CODE = 'ADD_CODE';
export const DELETE_CODE = 'DELETE_CODE';
export const SEARCH_CRITERIA = 'SEARCH_CRITERIA';